<template>
  <section>
    <img :src="imgs[0]"  @click.stop="$emit('imgView')">
  </section>
</template>

<script>
export default {
  props: ['imgs'],
  name: 'picGroup'
}
</script>

<style scoped>
  img{
    width: 286px;
    height: 214px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/picGroup.vue